import styled from "styled-components";
import StandardButton from "common/components/styled-components/StandardButton";

export default styled(StandardButton)`
  padding: 12px 24px;
  font-size: 16px;
  border: none;
  border-radius: 2px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;

  &:only-of-type {
    align-self: flex-start;
  }
`;
